
import { computed, defineComponent, onMounted, ref, toRefs } from "vue";
import { OptionsClass, StateCondition } from "@/domain/entities/MainApp";
import { PosLeaderboard } from "@/domain/entities/PosLeaderboard";
import CardLiolio from "./card-liolio.vue";
import CardRanking from "./card-ranking.vue";
import CardReward from "./card-reward.vue";
import FilterMonthLeaderBoard from "./leaderboard-month-filter.vue";
import { FILTER_MONTH_LEADERBOARD_KEYS } from "../LeaderboardUtils";

export default defineComponent({
  name: "Summary",
  emits: ["filter"],
  components: { CardLiolio, CardRanking, CardReward, FilterMonthLeaderBoard },
  props: {
    modelValue: {
      type: PosLeaderboard,
      default: new PosLeaderboard(),
      required: true
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    /* ---------- Props ---------- */
    const summaryData = computed(() => props.modelValue);

    /* ---------- State ---------- */
    const filterSummary = ref(new OptionsClass());

    /* ---------- Flags ---------- */
    const isCurrentMonth = computed(
      () =>
        filterSummary.value.key === FILTER_MONTH_LEADERBOARD_KEYS.CURRENT_MONTH
    );
    const isLastMonth = computed(
      () => filterSummary.value.key === FILTER_MONTH_LEADERBOARD_KEYS.LAST_MONTH
    );

    /* ---------- Cards ---------- */
    const hasAreaOrNewPos = computed(
      () =>
        summaryData.value.cards.area?.rank ||
        summaryData.value.cards.newPos?.rank
    );

    const areaOrNewPosCard = computed(() =>
      summaryData.value.cards.area?.rank
        ? summaryData.value.cards.area
        : summaryData.value.cards.newPos
    );

    /* ---------- UI ---------- */
    const headerStyle = {
      height: "271px",
      background:
        "linear-gradient(132.4deg, #FFD1D1 42.78%, rgba(255, 211, 67, 0.3) 123.7%)"
    };

    const filterButtonClass = (item: StateCondition) =>
      item.selected
        ? "bg-red-lp-2000 text-white font-bold"
        : "text-black-lp-300";

    /* ---------- API ---------- */
    const selectFilter = (filter: OptionsClass) => {
      filterSummary.value = filter;
      emit("filter", filter);
    };

    return {
      ...toRefs(props),
      filterSummary,
      summaryData,

      isLastMonth,
      isCurrentMonth,

      hasAreaOrNewPos,
      areaOrNewPosCard,

      headerStyle,
      filterButtonClass,
      selectFilter
    };
  }
});
